import { create, w } from '@dojo/framework/core/vdom';
import { ChartBase } from './base-chart';
const factory = create({}).properties();
export const HorizontalBarChart = factory(({ properties }) => {
    const { ariaLabel = 'bar chart', size, data, drawComplete, legend, options, plugins, pluginCode, title, alternateText } = properties();
    const type = 'horizontalBar';
    return w(ChartBase, {
        ariaLabel,
        alternateText,
        size,
        data,
        drawComplete,
        legend,
        options,
        plugins,
        pluginCode,
        title,
        type
    });
});
